function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import Modal from 'react-modal';
import React, { useState } from 'react';
import { T, useTranslate } from 'shared/helper/translate';
var FileLink = function FileLink(_ref) {
  var file = _ref.file;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalDisplayed = _useState2[0],
    setModalDisplayed = _useState2[1];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, file.expired ? /*#__PURE__*/React.createElement("div", {
    className: "action-link d-block text-truncate"
  }, file.name) : /*#__PURE__*/React.createElement("button", {
    className: "action-link d-block text-truncate w-100",
    type: "button",
    onClick: function onClick() {
      return setModalDisplayed(true);
    }
  }, file.name), /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: modalDisplayed,
    contentLabel: "download-file-heading",
    overlayClassName: "react-modal-overlay",
    className: "react-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return setModalDisplayed(false);
    },
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h4", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "download-file-heading"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "download-file-disclaimer"
  }), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('return-to-order-page-cta'),
    type: "button",
    onClick: function onClick() {
      return setModalDisplayed(false);
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "return-to-order-page-cta"
  })), /*#__PURE__*/React.createElement("a", {
    "aria-label": t('original-file-download-link', {
      fileName: file.name
    }),
    className: "d-block mt-3 text-break",
    href: "/api/file/".concat(file.identity, "/download"),
    onClick: function onClick() {
      return setModalDisplayed(false);
    }
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "original-file-download-link",
    params: {
      fileName: file.name
    }
  })))));
};
export default FileLink;